import React from "react";

import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { IconButton, Tooltip } from "@mui/material";

import CustomChip from 'ui/CustomChip';

const stateLabels = {
  pending: "Pending",
  shipped: "Shipped",
  delivered: "Delivered",
};

const stateStyles = {
  pending: "warning",
  shipped: "store",
  delivered: "active",
};

const renderFulfillmentState = (state) => (
  <CustomChip
    label={stateLabels[state] || state}
    styleKey={stateStyles[state]}
  />
);

const formatAddress = (shippingAddress) => {
  if (!shippingAddress) return "";

  const { name, address, post_code, city, country } = shippingAddress;
  return [name, address, post_code, city, country].filter(Boolean).join(", ");
};

// The table is a read-only queue index — all shipping actions happen in the
// order details modal opened by the magnifier (SELL05).
export const getFulfillmentColumns = (onOpenDetails) => [
  {
    field: "order_id",
    name: "Order ID",
    selector: (row) => row.order_id,
    sortable: true,
    width: "120px",
  },
  {
    field: "fulfillment_state",
    name: "Status",
    selector: (row) => stateLabels[row.fulfillment_state] || row.fulfillment_state,
    cell: (row) => renderFulfillmentState(row.fulfillment_state),
    sortable: true,
    width: "150px",
  },
  {
    field: "user",
    name: "Buyer",
    selector: (row) => row.user_email,
    sortable: true,
    width: "250px",
  },
  {
    field: "shipping_address",
    name: "Ship to",
    selector: (row) => formatAddress(row.shipping_address),
    grow: 1,
    minWidth: "250px",
  },
  {
    field: "details",
    name: "",
    allowOverflow: true,
    right: true,
    style: { cursor: "default" },
    cell: (row) => (
      <Tooltip title="See Details">
        <IconButton onClick={() => onOpenDetails(row)} size="small">
          <ZoomInIcon />
        </IconButton>
      </Tooltip>
    ),
    width: "60px",
  },
];
